export default __webpack_public_path__ + "static/media/wiitheme.d4e6ded8.mp3";